/**
 * App Config File
 * process.env.NODE_ENV === "production"
            ? "https://nos1.umbrella-travel.com"
            : "http://localhost:4001"

            https://laravel-itqan-insurances-system.test/itqanapi
 */
const AppConfig = {
  serverLink: window.location.origin,
  apiLink:
    process.env.NODE_ENV === "production"
      ? "https://" + window.location.host + "/itqanapi"
      : "https://itqan-insurances-system-laravel.test/itqanapi",
  storagePath:
    process.env.NODE_ENV === "production"
      ? "/storage/"
      : "https://itqan-insurances-system-laravel.test/storage/",
  generatedInvoicePath: "/generated-pdfs",
  // apiLink: "https://itqan-insurances-system-laravel.test/itqanapi",
  // storagePath: "https://itqan-insurances-system-laravel.test/storage/",
  baseRoute: "eee", // App Logo
  navCollapsed: false, // Sidebar collapse
  darkMode: false, // Dark Mode
  boxLayout: false, // Box Layout
  rtlLayout: false, // RTL Layout
  miniSidebar: false, // Mini Sidebar
  enableSidebarBackgroundImage: true, // Enable Sidebar Background Image
  isDarkSidenav: true, // Set true to dark sidebar
  enableThemeOptions: true, // Enable Theme Options
  locale: {
    languageId: "english",
    locale: "en",
    name: "English",
    icon: "en",
  },
  enableUserTour: false,
  // light theme colors
  themeColors: {
    primary: "#199b8b",
    secondary: "#677080",
    success: "#00b224",
    danger: "#FF3739",
    warning: "#FFB70F",
    info: "#00D0BD",
    dark: "#464D69",
    default: "#FAFAFA",
    greyLighten: "#A5A7B2",
    grey: "#677080",
    white: "#FFFFFF",
    purple: "#896BD6",
    yellow: "#D46B08",
  },
  // dark theme colors
  darkThemeColors: {
    darkBgColor: "#424242",
  },
  pageTableSize: 10,
  systemAgencyId: 1,
  agenciesWithDiscountPermission: [1, 326, 196, 3039]
};

export default AppConfig;
